var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "76FD5554-DEF6-4F13-8444-C9D7B82AAAAF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assinaturas-ecj-vitalicia-cor2",
    transform: "translate(-548.000000, -4026.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "incluido",
    transform: "translate(0.000000, 3618.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.000000, 184.000000)",
    id: "ic-cast"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "headphones",
    transform: "translate(3.000000, 3.000000)",
    fill: "#1717CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,-0.999999866 C14.4292399,-0.999999866 18.8479317,3.32667089 18.9961582,8.72009529 L19,9.00000013 L19,15.0000001 C19,15.5522849 18.5522847,16.0000001 18,16.0000001 C17.4871642,16.0000001 17.0644928,15.6139599 17.0067277,15.1166213 L17,15.0000001 L17,9.00000013 C17,4.5817221 13.418278,1.00000013 9,1.00000013 C4.66508574,1.00000013 1.13545713,4.44783787 1.00380682,8.7508208 L1,9.00000013 L1,15.0000001 C1,15.5522849 0.55228475,16.0000001 0,16.0000001 C-0.512835839,16.0000001 -0.935507161,15.6139599 -0.993272269,15.1166213 L-1,15.0000001 L-1,9.00000013 C-1,3.4771526 3.47715251,-0.999999866 9,-0.999999866 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,10 C18.5128358,10 18.9355072,10.3860402 18.9932723,10.8833789 L19,11 L19,16 C19,17.5976809 17.75108,18.9036609 16.1762728,18.9949073 L16,19 L15,19 C13.4023191,19 12.0963391,17.75108 12.0050927,16.1762728 L12,16 L12,13 C12,11.4023191 13.24892,10.0963391 14.8237272,10.0050927 L15,10 L18,10 Z M3,10 C4.59768088,10 5.90366088,11.24892 5.99490731,12.8237272 L6,13 L6,16 C6,17.5976809 4.75108004,18.9036609 3.17627279,18.9949073 L3,19 L2,19 C0.402319117,19 -0.903660879,17.75108 -0.994907307,16.1762728 L-1,16 L-1,11 C-1,10.4871642 -0.61395981,10.0644928 -0.116621125,10.0067277 L0,10 L3,10 Z M17,12 L15,12 C14.4871642,12 14.0644928,12.3860402 14.0067277,12.8833789 L14,13 L14,16 C14,16.5128358 14.3860402,16.9355072 14.8833789,16.9932723 L15,17 L16,17 C16.5128358,17 16.9355072,16.6139598 16.9932723,16.1166211 L17,16 L17,12 Z M3,12 L1,12 L1,16 C1,16.5128358 1.38604019,16.9355072 1.88337887,16.9932723 L2,17 L3,17 C3.51283584,17 3.93550716,16.6139598 3.99327227,16.1166211 L4,16 L4,13 C4,12.4871642 3.61395981,12.0644928 3.11662113,12.0067277 L3,12 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCast);
export default __webpack_public_path__ + "static/media/ic-cast.15ef4ba33f3860dd66a655bd49d6fcb0.svg";
export { ForwardRef as ReactComponent };